import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import { ReuploadImgSvg, PlusSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { useSourceImgUpload } from "@/hooks";
import { Loading } from "@/components";

const SourceImgUploaderMobile = () => {
  const { t } = useTranslation();
  const { loading, handleClick } = useSourceImgUpload();
  const generating = useCommonStore(state => state.generating);
  const sourceImgBlobUrl = useCommonStore(state => state.sourceImgBlobUrl);

  return (
    <div
      className={styles["source_img_uploader_mobile"]}
    >
      {sourceImgBlobUrl ? (
        <div
          className={styles["source_img_wrapper"]}
        >
          <button
            className={styles["reupload_button"]}
            disabled={generating}
            onClick={handleClick}
          >
            <ReuploadImgSvg></ReuploadImgSvg>
          </button>

          <img 
            className={styles["source_img"]}
            src={sourceImgBlobUrl}
            alt=""
          />
        </div>
      ) : (
        <div
          className={styles["uploader"]}
        >
          <div
            className={styles["box"]}
          >
            {loading ? (
              <Loading isBlack width={40} height={40}></Loading>
            ) : (
              <button
                className={styles["upload_button"]}
                disabled={generating}
                onClick={handleClick}
              >
                <PlusSvg></PlusSvg>
              </button>
            )}
            

            <span
              className={styles["text"]}
            >
              {t("upload_img_button")}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default SourceImgUploaderMobile;